<template>
  <app-card>
    <!-- <v-row class="pl-2 pr-2 justify-space-between"> -->

    <v-row class="pl-4 pr-2 justify-space-between">
      <!-- <div>

        <p class="mt-4 ml-2 text-h6">ผลการค้นหา</p>

      </div> -->

      <div class="align-self-center">
        <span>จำนวนรายการ </span>

        <span class=" primary--text">{{ list.length }}</span>

        <span> รายการ</span>
      </div>

      <v-pagination
        v-model="page"
        class="d-inline-flex "
        :length="totalPage"
        :total-visible="7"
        circle
        @input="onChangePage"
      />
    </v-row>

    <div>
      <v-fade-transition>
        <v-overlay :value="overlay" absolute>
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-fade-transition>

      <div v-if="list.length > 0">
        <v-card
          v-for="(item, index) in list"
          :key="index"
          class="pa-3 mx-1 my-3"
          elevation="4"
        >
          <v-row>
            <v-col cols="12" sm="6">
              <div>
                <span class="font-weight-bold">เขียนเมื่อ </span>

                <span>{{ item[`leaveAssignDate${$lang}`] }}</span>

                <span> : </span>

                <span>{{ item.leaveOrderID }}</span>

                <span> - </span>

                <span>{{ item[`leaveTypeName${$lang}`] }}</span>
              </div>

              <div>
                <span class="font-weight-bold">ชื่อผู้ขอลา </span>

                <span>{{ item[`employeeName${$lang}`] }}</span>
              </div>

              <div>
                <span class="font-weight-bold">วันที่ขอลา </span>

                <span>{{ item[`leaveBeginDate${$lang}`] }}</span>

                <span> - </span>

                <span>{{ item[`leaveFinishDate${$lang}`] }}</span>

                <span> จำนวน </span>

                <span>{{ item.leaveAmountDayText }}</span>
              </div>

              <div>
                <span class="font-weight-bold">สถานะล่าสุด </span>

                <v-chip class="white--text my-1" color="info" small>
                  {{ item[`approvedStatusName${$lang}`] }}
                </v-chip>
              </div>

              <div>
                <span class="font-weight-bold">สถานะ </span>

                <v-chip class="white--text my-1" :color="item.color" small>
                  {{ item[`leaveStatusName${$lang}`] }}

                  <span>{{ item[`empApproveName${$lang}`] }} </span>
                </v-chip>
              </div>

              <div class="mx-2">
                <span class="ml-n2">{{ item.numberForApproveType }}</span>

                <span v-if="item.approveDate">
                  เมื่อ {{ item[`approveDate${$lang}`] }}
                </span>
              </div>
            </v-col>

            <v-col>
              <div v-if="!!item.backEmployeeNameTha" class="error--text">
                <div>
                  ถูกส่งคืนจาก {{ item[`backEmployeeName${$lang}`] }} เมื่อ

                  {{ item[`backDate${$lang}`] }}
                </div>

                <div>เหตุผลในการส่งคืน {{ item.backDescription }}</div>
              </div>

              <div>
                <v-btn
                  class="teal white--text ma-1"
                  small
                  depressed
                  @click="onOpenLeaveDocument(item)"
                >
                  <v-icon class="pr-1" small>mdi-file-document</v-icon>

                  เปิดดูใบลา
                </v-btn>

                <v-btn
                  v-if="item.docFileName"
                  class="ma-1"
                  small
                  depressed
                  dark
                  @click="onOpenDocument(item)"
                >
                  <v-icon class="pr-1" small>mdi-file-document</v-icon>

                  <span class="px-1">
                    เปิดดูเอกสารแนบ
                  </span>
                </v-btn>

                <v-btn
                  v-if="item.leaveStatusID === 'W'"
                  class="success darken-3 white--text ma-1"
                  :to="
                    `/leave/approve/emp/${item.employeeID}/order/${item.leaveOrderID}/timeline`
                  "
                  small
                  depressed
                  rel="opener"
                >
                  <v-icon class="pr-1" small>mdi-check</v-icon>

                  เห็นชอบ/อนุญาตใบลา
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>

      <div v-else class="text-center grey--text">
        <span>ไม่มีข้อมูล</span>
      </div>
    </div>

    <div class="py-3 text-right">
      <v-pagination
        v-model="page"
        class="d-inline-flex"
        :length="totalPage"
        :total-visible="7"
        circle
        @input="onChangePage"
      />
    </div>
  </app-card>
</template>

<script>
export default {
  data() {
    return {
      overlay: false,

      page: 1,

      totalPage: 1,

      list: [],

      countTotal: 0
    }
  },

  watch: {
    $route() {
      this.onSearchBegin()
    }
  },

  async mounted() {
    await this.onSearch()

    //console.log(this.$nowYear)
  },

  methods: {
    async onSearchBegin() {
      this.$route.query.PageIndex = 0

      await this.onSearch()
    },

    async onSearch() {
      this.overlay = true

      let result = []

      try {
        result = await this.apiPostSearchApproval()

        this.totalPage = result.totalPage

        this.list = result.items
      } catch (e) {
        console.log(e.response || e)
      }

      this.overlay = false
    },

    async onOpenLeaveDocument(item) {
      let path = `/pdf?store=leave/getLeaveDocumentDownload&FileType=pdf&guid=${item.employeeID}&leaveOrderID=${item.leaveOrderID}`

      window.open(path)
    },

    async onOpenDocument(item) {
      try {
        const payload = {
          leaveOrderID: item.leaveOrderID,

          docFileName: item.docFileName
        }

        const res = await this.$store.dispatch(
          'leave/getAttachedDocumentDownload',
          payload
        )

        var fileURL = window.URL.createObjectURL(
          new Blob([res.data], { type: 'application/pdf' })
        )

        var link = document.createElement('a')

        link.href = fileURL

        link.download = item.docFileName

        link.click()
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async onChangePage() {
      this.$route.query.PageIndex = parseInt(this.page) - 1

      await this.onSearch()
    },

    async apiPostSearchApproval() {
      let body = {
        PageIndex: 0,

        LeaveTypeID: '0',

        LeaveStatusID: 'W',

        Month: '0',

        Year: '0',

        Keyword: '',

        RowsPerPage: 10
      }

      const query = this.$route.query

      body = { ...body, ...query }

      try {
        const res = await this.$store.dispatch('leave/postSearchApproval', body)

        if (
          res.data.hasOwnProperty('data') &&
          Array.isArray(res.data.data) &&
          res.data?.data[0].hasOwnProperty('items')
        ) {
          // if (res.data?.data[0].hasOwnProperty('items')) {

          const list = res.data?.data[0].items.map(item => {
            item.leaveAssignDateTha = this.$dateFormatByLang(
              item.leaveAssignDate,
              {
                format: 'DD MMMM YYYY',

                addUnit: 'y',

                addValue: 543
              }
            )

            item.leaveAssignDateEng = this.$dateFormat(item.leaveAssignDate, {
              format: 'DD MMMM YYYY',

              locale: 'en'
            })

            item.leaveBeginDateTha = this.$dateFormatByLang(
              item.leaveBeginDate,
              {
                format: 'DD MMMM YYYY',

                addUnit: 'y',

                addValue: 543
              }
            )

            item.leaveBeginDateEng = this.$dateFormat(item.leaveBeginDate, {
              format: 'DD MMMM YYYY',

              locale: 'en'
            })

            item.leaveFinishDateTha = this.$dateFormatByLang(
              item.leaveFinishDate,
              {
                format: 'DD MMMM YYYY',

                addUnit: 'y',

                addValue: 543
              }
            )

            item.leaveFinishDateEng = this.$dateFormat(item.leaveFinishDate, {
              format: 'DD MMMM YYYY',

              locale: 'en'
            })

            item.approveDateTha = this.$dateFormatByLang(item.approveDate, {
              format: 'DD MMMM YYYY',

              addUnit: 'y',

              addValue: 543
            })

            item.approveDateEng = this.$dateFormat(item.approveDate, {
              format: 'DD MMMM YYYY',

              locale: 'en'
            })

            if (item.backDate) {
              item.backDateTha = this.$dateFormatByLang(item.backDate, {
                format: 'DD MMMM YYYY',

                addUnit: 'y',

                addValue: 543
              })

              item.backDateEng = this.$dateFormat(item.backDate, {
                format: 'DD MMMM YYYY',

                locale: 'en'
              })
            }

            return item
          })

          return {
            items: list,

            totalPage: res.data?.data[0].hasOwnProperty('countrow')
              ? Math.ceil(parseInt(res.data?.data[0].countrow) / 10)
              : 0
          }
        }

        return res.data?.data[0] || {}
      } catch (e) {
        console.log(e.response || e)

        this.countTotal = 0

        this.totalPage = 0

        this.list = []
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
